import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FileText, Mail, Menu, ShieldCheck, X } from "lucide-react";

export default function MenuDrawer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        data-testid="menu-button"
        onClick={() => setOpen(true)}
        aria-label="Open menu"
        className="fixed right-4 top-4 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-white/90 text-[#0A0A0A] shadow-[0_8px_24px_-8px_rgba(0,0,0,0.25)] backdrop-blur transition-transform duration-200 hover:scale-105 active:scale-95 sm:right-6 sm:top-6"
      >
        <Menu className="h-5 w-5" strokeWidth={2.4} />
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            key="menu-drawer"
            data-testid="menu-drawer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          >
            <motion.aside
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 28, stiffness: 300 }}
              onClick={(e) => e.stopPropagation()}
              className="absolute right-0 top-0 flex h-full w-[300px] flex-col bg-white px-6 py-6 shadow-2xl sm:w-[340px]"
            >
              <div className="flex items-center justify-between">
                <div className="text-[18px] font-extrabold tracking-tight">
                  Ne<span className="text-[#F25C05]">X</span>strength
                </div>
                <button
                  data-testid="menu-close-button"
                  onClick={() => setOpen(false)}
                  aria-label="Close menu"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-neutral-100 text-neutral-500 transition-colors hover:bg-neutral-200"
                >
                  <X className="h-[18px] w-[18px]" />
                </button>
              </div>

              <div className="mt-9 flex flex-col gap-2">
                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400">Reach us</span>
                <a
                  data-testid="menu-contact-email"
                  href="mailto:nexstrengthbusiness@gmail.com"
                  className="flex items-center gap-3 rounded-xl border border-neutral-100 px-4 py-3 transition-colors hover:border-neutral-200"
                >
                  <Mail className="h-[18px] w-[18px] shrink-0 text-[#F25C05]" />
                  <span className="flex flex-col">
                    <span className="text-[13.5px] font-bold">Email Us</span>
                    <span className="text-[12px] font-medium text-neutral-500">nexstrengthbusiness@gmail.com</span>
                  </span>
                </a>
              </div>

              <div className="mt-8 flex flex-col gap-1">
                <span className="mb-1 text-[11px] font-bold uppercase tracking-[0.14em] text-neutral-400">Legal</span>
                <Link
                  data-testid="menu-link-privacy"
                  to="/privacy-policy"
                  className="flex items-center gap-3 rounded-xl px-4 py-3 transition-colors hover:bg-neutral-50"
                >
                  <ShieldCheck className="h-[18px] w-[18px] shrink-0 text-[#F25C05]" />
                  <span className="text-[13.5px] font-bold">Privacy Policy</span>
                </Link>
                <Link
                  data-testid="menu-link-terms"
                  to="/terms-and-conditions"
                  className="flex items-center gap-3 rounded-xl px-4 py-3 transition-colors hover:bg-neutral-50"
                >
                  <FileText className="h-[18px] w-[18px] shrink-0 text-[#F25C05]" />
                  <span className="text-[13.5px] font-bold">Terms &amp; Conditions</span>
                </Link>
              </div>

              <div className="mt-auto pb-2 text-[11px] font-medium text-neutral-400">
                Business Consultancy — nexstrength.com
              </div>
            </motion.aside>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
